var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOops = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 68C136 30.4446 105.555 0 68 0C30.4446 0 0 30.4446 0 68C0 105.555 30.4446 136 68 136C105.555 136 136 105.555 136 68Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1159 109.536C82.6262 109.536 94.3887 107.656 94.3887 105.337C94.3887 103.018 82.6262 101.139 68.1159 101.139C53.6062 101.139 41.8433 103.018 41.8433 105.337C41.8433 107.656 53.6062 109.536 68.1159 109.536Z",
    fill: "#F1EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1087 37.5489C64.139 43.9935 78.0017 45.1114 82.4784 45.3071C74.4265 60.8698 79.6914 109.309 79.6914 109.309L84.2196 108.923C84.2196 108.923 77.2753 60.5298 89.572 45.5596C89.6699 45.5338 103.996 41.5929 103.095 34.3292C102.193 27.0656 85.6362 26.0868 81.9323 26.298C78.2284 26.5092 61.8826 29.8474 63.1087 37.5489Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2196 108.939C84.2196 108.939 76.9611 59.8189 90.5302 44.452",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6914 109.309C79.6914 109.309 74.4111 60.8389 82.5196 45.2297",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.572 45.575C89.572 45.575 103.996 41.6342 103.095 34.3448C102.193 27.0554 85.6362 26.1023 81.9323 26.3135C78.2283 26.5247 61.8414 29.863 63.1086 37.5645C64.3759 45.266 83.8692 45.3639 83.8692 45.3639",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.096 30.8004C97.0932 34.6589 70.1868 40.4698 63.4899 35.2925",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4829 69.6789C37.0266 74.3719 49.0245 67.3864 52.8159 64.991C55.0877 82.3671 64.3965 109.454 64.3965 109.454H69.9808C69.9808 109.454 57.2462 80.461 58.7917 61.1428C58.8587 61.0655 68.3632 49.66 63.4796 44.2046C58.5959 38.7491 44.4499 47.414 41.5187 49.6961C38.5874 51.9783 27.0584 64.074 32.4829 69.6789Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9807 109.454C69.9807 109.454 56.5868 80.0231 58.9256 59.6592",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3965 109.453C64.3965 109.453 55.0568 82.3459 52.8056 64.9029",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7916 61.148C58.7916 61.148 68.3838 49.6758 63.4795 44.2049C58.5753 38.734 44.4499 47.4143 41.5187 49.6964C38.5875 51.9783 27.0944 64.074 32.4932 69.6789C37.892 75.2837 53.9904 64.2286 53.9904 64.2286",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.822 42.4477C58.735 47.9031 39.9526 68.0402 31.5299 67.5972",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.908 105.333C104.908 107.651 88.2584 109.526 68.1159 109.526C47.9736 109.526 31.3239 107.651 31.3239 105.333",
    stroke: "#171515",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOops);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/oops.d09d3ae97ad6617089147b13dc3a8b5c.svg";